import * as React from 'react';
import { X } from 'lucide-react';
import { cn } from '@/lib/utils';

export interface WfModalProps extends Omit<React.HTMLAttributes<HTMLDivElement>, 'title'> {
  /** Título do header (wireframe .dl-h). Header só renderiza se title ou onClose. */
  title?: React.ReactNode;
  /** Ícone opcional à esquerda do título. */
  icon?: React.ReactNode;
  /** Renderiza o botão X (wireframe .closex) e dispara no clique. */
  onClose?: () => void;
  /** Conteúdo do footer (wireframe .dl-f). Footer só renderiza se fornecido. */
  footer?: React.ReactNode;
  /** Variante larga (wireframe dialog.wide — 760px). */
  wide?: boolean;
}

/**
 * Caixa de modal do wireframe (dialog + .dl-h/.dl-b/.dl-f). Burro: NÃO gerencia
 * overlay/portal/foco — montar dentro do mecanismo de dialog existente
 * (Radix/HTML dialog) com .wf-modal-backdrop no overlay quando aplicável.
 */
export const WfModal = React.forwardRef<HTMLDivElement, WfModalProps>(
  ({ title, icon, onClose, footer, wide = false, className, children, ...props }, ref) => (
    <div ref={ref} className={cn('wf-modal', wide && 'wf-modal--wide', className)} {...props}>
      {(title != null || onClose) && (
        <div className="wf-modal-header">
          {icon}
          {title}
          {onClose && (
            <button type="button" className="wf-modal-close" onClick={onClose} aria-label="Fechar">
              <X className="ic" />
            </button>
          )}
        </div>
      )}
      <div className="wf-modal-body">{children}</div>
      {footer != null && <div className="wf-modal-footer">{footer}</div>}
    </div>
  )
);
WfModal.displayName = 'WfModal';
